import type { Quiz, QuizQuestionChoice } from '@efdigital/ll-addon-data';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import BsDropdown from 'ember-bootstrap/components/bs-dropdown';

export interface ScoringWizardSignature {
  Args: {
    questionData: QuizQuestionChoice;
    quiz: Quiz;
  };
  Element: HTMLDivElement;
}

export class ScoringWizard extends Component<ScoringWizardSignature> {
  setSameCategoryAndAscendingScores = (offset: number, close: () => void) => {
    const options = this.args.questionData.choices;

    if (options.length === 0) {
      close();
      return;
    }

    // Get the category from the first option, or use empty string if none
    const firstCategory = options[0]?.category || '';

    // Update all options with the same category and ascending scores
    options.forEach((option, index) => {
      option.category = firstCategory;
      option.score = index + offset;
      // Clear additional categories
      option.additionalCategories = [];
    });

    close();
  };

  <template>
    <BsDropdown ...attributes as |dd|>
      <dd.toggle
        class="btn btn-white btn-sm py-1 btn-magical-border bs-hide-caret"
        aria-label="Scoring wizard"
      >
        <iconify-icon inline icon="ph:sparkle" class="fs-4" />
        <span class="visually-hidden">Wizard</span>
      </dd.toggle>

      <dd.menu as |ddm|>
        <ddm.item>
          <button
            type="button"
            class="dropdown-item text-wrap"
            {{on
              "click"
              (fn this.setSameCategoryAndAscendingScores 1 dd.closeDropdown)
            }}
          >
            <span class="d-block fw-bold">
              <iconify-icon inline icon="ph:list-numbers-bold" />
              Number each option (1, 2, 3, ...)
            </span>
            <span class="d-block small lh-sm">
              Assign the same category to all options and set their scores to 1,
              2, 3... in ascending order
            </span>
          </button>

          <button
            type="button"
            class="dropdown-item text-wrap"
            {{on
              "click"
              (fn this.setSameCategoryAndAscendingScores 0 dd.closeDropdown)
            }}
          >
            <span class="d-block fw-bold">
              <iconify-icon inline icon="ph:list-numbers-bold" />
              Number each option (0, 1, 2, ...)
            </span>
            <span class="d-block small lh-sm">
              Assign the same category to all options and set their scores to 0,
              1, 2... in ascending order
            </span>
          </button>
        </ddm.item>
      </dd.menu>
    </BsDropdown>
  </template>
}
